import { __ } from "@wordpress/i18n";
import React, { useEffect, useState } from 'react';
import SuccessTick from '../assets/images/success-tick.svg';
import Hint from '../components/Hint/Hint';
import InfoBox from '../components/InfoBox/InfoBox';
import PageHeading from '../components/PageHeading/PageHeading';
import Switch from '../components/Switch/Switch';
import { useMenu } from '../contexts/MenuContext';
import withForm from '../pages/withForm';
const LoginTemporaryLoginExpress = ({handleChange}) => {

    const {
        settingData
    } = useMenu();

    const [pageList,setPageList] = useState([])
    useEffect(()=>{
        setPageList([
            { code: "wp-admin", value: __( "Dashboard", 'ultimate-security' ) },
            { code: "home", value: __( "Website Home Page", 'ultimate-security' ) },
            ...(ultimate_security_ajax_obj?.pageList || []),
        ]);
    },[settingData]) 

    const [processing, setProcessing] = useState(false)
    const [processingRing, setProcessingRing] = useState(false)
    const [processingTick, setProcessingTick] = useState(false)
    const handleAction = async() => {
        setProcessing(true);
        setProcessingRing(true);

        try {
            const response = await fetch('/wp-admin/admin-ajax.php?action=plulsc_download_users_csv&security='+ultimate_security_ajax_obj.security, {
                method: 'GET',
                credentials: 'include', // Include cookies if necessary for authentication
                headers: {
                    'Content-Type': 'application/octet-stream'
                }
            });
    
            if (!response.ok) {
                throw new Error('Failed to download file');
            }

            setProcessingRing(false);
            setProcessingTick(true)
            
            setTimeout(()=> {
                setProcessingTick(false)
                setProcessing(false)
            },1000)
    
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = new Date().toISOString().split('T')[0] + '_users.csv'; // Set the filename
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error downloading CSV:', error);
            
            setProcessing(false);
            setProcessingRing(false);
        }      
    }

    
    return (
        <>
            <div className="setting-unit px-lg" style={{marginLeft:'-30px', marginRight:'-30px'}}>
                <PageHeading 
                    title={__("General Settings", "ultimate-security")}
                    subtitle={__("Streamline access with secure, temporary express login links—no passwords required. Perfect for quick, hassle-free user access for your user base!", "ultimate-security")}
                />
            </div>
            <div className="setting-unit pt-lg mt-lg pb-lg border-top">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Enable Express Login", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Toggle this option to enable or disable Express Login for your user lists.", "ultimate-security")}</p>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("No Hint", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Enable", "ultimate-security")}</h6>
                                </div>
                            </div>
                            
                            <div className="col-auto">
                                <Switch 
                                    name="login.express_login.enable"
                                    checked={settingData?.login?.express_login?.enable} // Pass "1"/"0" from API 
                                    onChange={handleChange} 
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit pt-lg pb-lg mb-lg border-bottom">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Secret Key", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("The Secret Key is used to generate unique, secure Express Login links.", "ultimate-security")}</p>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("No Hiint", "ultimate-security")}/>
                                    <input 
                                        className="form-control"
                                        type="text"
                                        value={settingData?.login?.express_login?.secret_key}
                                        onChange={(e) => handleChange("login.express_login.secret_key", e.target.value)}
                                    />
                                </div>
                                <div className="content-below-with-hint mt-2">                                    
                                    <InfoBox className="small-infobox" title={__( "Important", "ultimate-security" )} content={__( "Changing this key will invalidate all previously generated links. You need to set a unique key for the first time.", "ultimate-security" )} />
                                </div>
                            </div>   
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit px-lg" style={{marginLeft:'-30px', marginRight:'-30px'}}>
                <PageHeading 
                    title={__("Express Login Settings", "ultimate-security")}
                    subtitle={__("Manage the core settings for Express Login functionality in your WordPress site. Customize security and usability features to suit your needs.", "ultimate-security")}
                />
            </div>
            <div className="setting-unit pt-lg mt-lg pb-lg border-top">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Link Expiry (optional)", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Set an expiry period for generated express login links to enhance security and control.", "ultimate-security")}</p>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("No Hint", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Enable", "ultimate-security")}</h6>
                                </div>
                            </div>
                            
                            <div className="col-auto">
                                <Switch 
                                    name="login.express_login.enable_link_expiry"
                                    checked={settingData?.login?.express_login?.enable_link_expiry} // Pass "1"/"0" from API 
                                    onChange={handleChange} 
                                />
                            </div>
                        </div>
                        <div className="row justify-content-between mt-2">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("No Hint", "ultimate-security")}/>
                                    <div className="d-flex align-items-center">
                                        <span className="w-130">
                                            <input 
                                                className="form-control"
                                                type="number"
                                                min="0"
                                                value={settingData?.login?.express_login?.expires_after}
                                                onChange={(e) => handleChange('login.express_login.expires_after', e.target.value)}
                                            />
                                        </span>
                                        <div className={`units ${settingData?.login?.express_login?.expires_after < 1 ?'deactive-section':''}`}>
                                            <span 
                                                className={`unit ${settingData?.login?.express_login?.expiry_time == 'week'?'active-unit':''}`}
                                                onClick={()=>handleChange('login.express_login.expiry_time', 'week')}
                                            >
                                                {__("Week", "ultimate-security")}
                                            </span>
                                            <span
                                                className={`unit ${settingData?.login?.express_login?.expiry_time == 'month'?'active-unit':''}`}
                                                onClick={()=>handleChange('login.express_login.expiry_time', 'month')}
                                            >
                                                {__("Month", "ultimate-security")}
                                            </span>
                                        </div>
                                    </div>
                                    
                                </div>
                                <div className="content-below-with-hint mt-2">                                    
                                    <InfoBox className="small-infobox" title={__( "Important", "ultimate-security" )} content={__( "A new link will auto-generate after the specified period. The old link will become invalid.", "ultimate-security" )} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit pb-lg mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Redirect To", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Select the destination users will be redirected to after using an express login link.", "ultimate-security")}</p>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("No Hint", "ultimate-security")}/>
                                    <select 
                                        className="form-select"
                                        value={settingData?.login?.express_login?.redirect_to} 
                                        onChange={(e) => handleChange('login.express_login.redirect_to', e.target.value)}
                                    >
                                        {
                                            pageList.length && pageList.map(item=> (   
                                                <option 
                                                    value={item.code}
                                                    key={item.code} 
                                                >
                                                    {item.value}
                                                </option>                                     
                                            ))  
                                        }
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Export Users", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Easily export user data for backup or migration purposes.", "ultimate-security")}</p>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="d-flex align-items-center gap-2"> 
                                    <Hint content={__("No Hiint", "ultimate-security")}/>                                   
                                    <button 
                                        type="button" 
                                        className="button button-link" 
                                        onClick={handleAction}
                                        disabled={processing}
                                    >
                                        {
                                            processing ? __( "Processing...", "ultimate-security" ) : __( "Download .csv", "ultimate-security" )
                                        }
                                    </button>
                                    {processingRing && <span className="lds-ring"><span></span><span></span><span></span><span></span></span>}
                                    {processingTick && <img src={SuccessTick}/>}
                                </div>
                                <div className="content-below-with-hint mt-2">                                    
                                    <InfoBox className="small-infobox" title={__( "Note", "ultimate-security" )} content={__( "Generate a downloadable file containing user details to streamline data management tasks.", "ultimate-security" )} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default withForm(LoginTemporaryLoginExpress,'login.express_login');